<template>
  <div>
    <template v-for="num in 4">
      <SkeletonTheme :key="num + 4">
        <Skeleton height="3em" :duration="2" />
      </SkeletonTheme>
      <SkeletonTheme :key="num + 8" :duration="0" color="#ffj">
        <Skeleton height="3em" />
      </SkeletonTheme>
    </template>
  </div>
</template>

<script>
import { Skeleton, SkeletonTheme } from "vue-loading-skeleton"

export default {
  name: "TableLoadingSkeleton",
  components: {
    Skeleton,
    SkeletonTheme
  }
}
</script>

<style scoped></style>
